import React, { useEffect, useRef } from "react";
import styles from "../styles/UnitModifier.module.css";

interface PromptModalProps {
    isOpen: boolean;
    title?: string;
    label?: string;
    value: string;
    onChange: (val: string) => void;
    onSubmit: () => void;
    onCancel: () => void;
}

const PromptModal: React.FC<PromptModalProps> = ({
    isOpen,
    title = "Add Calendar Event",
    label = "Event Name",
    value,
    onChange,
    onSubmit,
    onCancel,
}) => {
    // All hooks at the top
    const inputRef = useRef<HTMLInputElement>(null);
    const overlayRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isOpen]);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") onCancel();
            if (e.key === "Enter") onSubmit();
        };
        if (isOpen) {
            window.addEventListener("keydown", handleKeyDown);
        }
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpen, onCancel, onSubmit]);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === overlayRef.current) {
            onCancel();
        }
    };

    // Conditional rendering after all hooks
    if (!isOpen) return null;

    return (
        <div
            ref={overlayRef}
            className={styles.modal}
            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            onClick={handleOverlayClick}
        >
            <div className={styles.modalContent} style={{ minWidth: "340px", padding: "2rem 2.5rem" }}>
                <h2 className={styles.modalTitle} style={{ marginBottom: "1.5rem", textAlign: "center" }}>{title}</h2>
                <label className={styles.modalLabel} style={{ display: "block", marginBottom: "1.25rem" }}>
                    {label}
                    <input
                        ref={inputRef}
                        className={styles.addUnitInput}
                        type="text"
                        value={value}
                        onChange={e => onChange(e.target.value)}
                        autoFocus
                        placeholder={label}
                        style={{ marginTop: "0.5rem", width: "100%" }}
                    />
                </label>
                <div className={styles.modalButtons} style={{ display: "flex", gap: "1rem", justifyContent: "center", marginTop: "2rem" }}>
                    <button
                        className={styles.addUnitBtn}
                        style={{ backgroundColor: "#43A047", color: "white", minWidth: "100px" }}
                        onClick={onSubmit}
                    >
                        Add
                    </button>
                    <button
                        className={styles.cancelBtn}
                        style={{ minWidth: "100px" }}
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PromptModal;
